<template>
  <div class="page-container">
    <div class="page-title">防伪查询</div>
    <el-form>
      <el-form-item :error="error">
        <el-input v-model.trim="code" placeholder="请输入16位数字防伪密码" size="normal" maxlength="16" clearable>
          <el-button slot="append" icon="el-icon-search" @click="checkCode()"></el-button>
        </el-input>
      </el-form-item>
    </el-form>
    <div class="result-area" v-if="result.show">
      <div class="result-title">查询结果</div>
      <div class="result-detail">
        <div><span>防伪编码：</span>{{result.code}}</div>
        <div v-if="result.num != 0"><span class="result-label">查询次数：</span>{{result.num}}</div>
        <div v-if="result.date != ''"><span class="result-label">首次查询时间：</span>{{result.date}}</div>
        <div><span class="result-label">查询结果：</span>{{result.des}}</div>
      </div>
    </div>
    <div class="notice-area">
      <div class="notice-title">验证提示</div>
      <div class="notice-des">
        请对照您所购买的产品上的防伪标识，依次输入防伪密码。验证结果分为以下三种情况
      </div>
      <div>
        <div class="notice-item">
          <div><img class="icon" src="@/assets/images/anti-fake/1.png"></div>
          <div>
            <div class="notice-title">正确查询</div>
            <div>即您所购买的商品为正品</div>
          </div>
        </div>
        <div class="notice-item">
          <div><img class="icon" src="@/assets/images/anti-fake/2.png"></div>
          <div>
            <div class="notice-title">重复查询</div>
            <div>重复查询即同一验证码被多次查验，请确认首次查验是否本人所为，若非本人所为，则可能为假冒商品</div>
          </div>
        </div>
        <div class="notice-item">
          <div><img class="icon" src="@/assets/images/anti-fake/3.png"></div>
          <div>
            <div class="notice-title">错误查询</div>
            <div>即验证码不存在，您所购买的产品未经官方验证</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      code: '',
      error: '',
      result: {
        code: '',
        num: 0,
        date: '',
        des: '',
        show: false
      }
    }
  },
  watch: {
    code () {
      if (this.code.length === 0) {
        this.error = ''
      }
    }
  },
  methods: {
    checkCode () {
      if (this.code.length === 16) {
        const regex = /^\d{16}$/
        if (regex.test(this.code)) {
          this.verifyCode(this.code)
        } else {
          this.error = '防伪码格式不正确,请输入16位数字防伪码'
        }
      } else {
        this.error = '防伪码格式不正确'
      }
    },
    verifyCode (code) {
      const that = this
      that.result.show = true
      that.result.des = '查询中...'
      that.axios.post('anti_fake', { code }).then(function (resp) {
        if (resp.data.success !== undefined) {
          that.result.code = code
          if (resp.data.success) {
            if (resp.data.details.query_times * 1 === 1) {
              that.result.num = 1
              that.result.date = '本次'
              that.result.des = '您好！您所查询的产品是正品行货，请放心使用！'
            } else if (resp.data.details.query_times * 1 > 8) {
              that.result.num = resp.data.details.query_times * 1
              that.result.date = resp.data.details.first_query_time
              that.result.des = '您好！该防伪码查询次数过多，已被冻结！！'
            } else {
              that.result.num = resp.data.details.query_times * 1
              that.result.date = resp.data.details.first_query_time
              that.result.des = '您好！您所查询的防伪码已被查询过，非第一次查询'
            }
          } else {
            that.result.num = 0
            that.result.date = ''
            that.result.des = '您好！该防伪码不存在!'
          }
        }
        console.log(resp.data)
      })
    }
  }
}
</script>

<style scoped>
.page-container{
  box-sizing: border-box;
  padding: 50px 10px;
  margin: 0 auto;
  max-width: 1200px;
}
.page-title{
  margin-bottom: 20px;
}
.result-area{
  margin-bottom: 50px;
}
.result-title{
  font-size: 17px;
  font-weight: bold;
  color: #194295;
  margin-bottom: 20px;
}
.notice-area{
  box-sizing: border-box;
  color: #333;
  padding-top: 20px;
}
.notice-item{
  display: flex;
  font-size: 17px;
  padding: 10px 0;
}
.icon{
  width: 50px;
  margin-right: 20px;
}
.notice-title{
  font-size: 17px;
  font-weight: bold;
  color: #194295;
  padding-bottom: 5px;
}
.notice-des{
  padding: 10px 0;
}
.result-detail{
  line-height: 30px;
  font-size: 16px;
  box-sizing: border-box;
  padding: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.result-label{
  color: #333;
}
</style>
